import { combineReducers } from 'redux';
import { merge, mergeWith } from 'lodash-es';

import {
  CLEAR_SURVEY_SCHEMA_PART_OPTIONS,
  UPDATE_SURVEY_SCHEMA_PART_OPTIONS,
  ADD_SCHEMA_PART_ITEM,
  UPDATE_SCHEMA_PART_ITEM,
  UPDATE_SCHEMA_PART_ITEM_ORDER,
  REMOVE_SCHEMA_PART_ITEM,
  ADD_VARIABLE,
  UPDATE_VARIABLE,
  REMOVE_VARIABLE
} from '../../actions';
import { publicationStatusValues, surveyPartTypeValues, surveyTypeValues } from '../../constants/types';
import { arrayOverwritingMergeCustomizer } from '../../util';

const defaultSchemaPartOptions = {
  id: 0,
  type: surveyPartTypeValues.SURVEY_SCHEMA_PART,
  surveyType: surveyTypeValues.DEGREE_PROGRAM_SURVEY,
  code: '',
  description: {},
  title: {},
  surveySchemaPartItems: [],
  variables: [],
  status: publicationStatusValues.DRAFT
};

const surveySchemaPartOptions = (state = defaultSchemaPartOptions, action) => {
  switch (action.type) {
    case UPDATE_SURVEY_SCHEMA_PART_OPTIONS: {
      const options = action.payload;
      return merge({}, state, options);
    }
    case ADD_SCHEMA_PART_ITEM: {
      const { surveySchemaPartItems } = state;
      return { ...state, surveySchemaPartItems: [...surveySchemaPartItems, action.payload] };
    }
    case UPDATE_SCHEMA_PART_ITEM: {
      const { index, item } = action.payload;
      const oldItem = state.surveySchemaPartItems[index];
      if (oldItem) {
        const surveySchemaPartItems =
          Object.assign(
            [],
            state.surveySchemaPartItems,
            { [index]: mergeWith({}, oldItem, item, arrayOverwritingMergeCustomizer) }
          );
        return { ...state, surveySchemaPartItems };
      }
      return state;
    }
    case UPDATE_SCHEMA_PART_ITEM_ORDER: {
      const surveySchemaPartItems =
        action.payload.map((item, idx) => ({ ...item, order: idx + 1 }));
      return { ...state, surveySchemaPartItems };
    }
    case REMOVE_SCHEMA_PART_ITEM: {
      const surveySchemaPartItems = state.surveySchemaPartItems
        .filter((item, index) => index !== action.payload)
        .map((item, index) => ({ ...item, order: index + 1 }));
      return { ...state, surveySchemaPartItems };
    }
    case ADD_VARIABLE: {
      const variables = state.variables || [];
      return { ...state, variables: [...variables, action.payload] };
    }
    case UPDATE_VARIABLE: {
      const { index, variable } = action.payload;
      const oldVariable = state.variables[index];
      if (oldVariable) {
        const variables =
          Object.assign(
            [],
            state.variables,
            { [index]: mergeWith({}, oldVariable, variable, arrayOverwritingMergeCustomizer) }
          );
        return { ...state, variables };
      }
      return state;
    }
    case REMOVE_VARIABLE: {
      const variables = state.variables.filter((v, idx) => idx !== action.payload);
      return { ...state, variables };
    }
    case CLEAR_SURVEY_SCHEMA_PART_OPTIONS:
      return defaultSchemaPartOptions;
    default:
      return state;
  }
};

const surveySchemaPart = combineReducers({
  surveySchemaPartOptions
});

export default surveySchemaPart;
